import { render } from "./Divider.vue?vue&type=template&id=2ff06b03&scoped=true"
import script from "./Divider.vue?vue&type=script&lang=js"
export * from "./Divider.vue?vue&type=script&lang=js"

import "./Divider.vue?vue&type=style&index=0&id=2ff06b03&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2ff06b03"

export default script